var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultimageprofile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427320954"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1297",
    cx: 20.8572,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#AA8453"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svgg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3024 9.40079C15.4093 10.0227 13.4123 15.8502 16.9431 19.204C20.4689 22.5532 26.3272 20.1724 26.5287 15.3084C26.6711 11.8739 23.6201 8.9791 20.3024 9.40079ZM21.7756 11.0137C24.948 11.7678 26.0914 15.6674 23.8155 17.9701C21.7047 20.1056 18.2049 19.4286 17.0155 16.6546C15.7126 13.6158 18.5545 10.248 21.7756 11.0137ZM19.4025 22.2921C15.042 22.909 11.9331 25.7861 11.6348 29.4807C11.5934 29.993 11.6507 30.206 11.8872 30.4197C12.3925 30.8761 13.1369 30.5307 13.1379 29.8393C13.1399 28.3338 14.0027 26.6751 15.3482 25.59C20.1262 21.7368 28.1906 24.2312 28.5605 29.6768C28.6009 30.2718 28.7265 30.4732 29.1331 30.595C30.7439 31.0776 30.2184 27.5808 28.3506 25.3883C26.3982 23.0964 22.7181 21.823 19.4025 22.2921Z",
    fill: "#AA8453"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultimageprofile);
export default __webpack_public_path__ + "static/media/defaultimageprofile.9924fbf16ea177befb94b139819a12ce.svg";
export { ForwardRef as ReactComponent };